// @flow
import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { resetAuth, loginUser, oAuthLoginUser } from '../redux/actions';
import jwt_decode from 'jwt-decode';
import { useLocation } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import AuthContext from '../context/auth-context';

import classNames from 'classnames';

// actions
import { changeSidebarType, showRightSidebar } from '../redux/actions';

// components
// import LanguageDropdown from '../components/LanguageDropdown';
// import NotificationDropdown from '../components/NotificationDropdown';
import ProfileDropdown from '../components/ProfileDropdown';
// import SearchDropdown from '../components/SearchDropdown';
// import TopbarSearch from '../components/TopbarSearch';
import AppsDropdown from '../components/AppsDropdown/';

// images
import profilePic from '../assets/images/users/avatar-1.jpg';
import noProfilePic from '../assets/images/users/no-profile-pic.png';
import siberianLogoWhite from '../assets/images/siberian_logo_white_text.png';
import siberianLogoText from '../assets/images/siberian_logo_with_text.png';

// import avatar1 from '../assets/images/users/avatar-2.jpg';
// import avatar2 from '../assets/images/users/avatar-4.jpg';
// import logoSmDark from '../assets/images/logo_sm_dark.png';
// import logoSmLight from '../assets/images/logo_sm.png';
// import logo from '../assets/images/logo-light.png';
// import logoOrangeWhite from '../assets/images/logo-orange-white.png';
// import siberianLogo from '../assets/images/siberian-logo-2.png';

//constants
import * as layoutConstants from '../constants/layout';
import { useEffect } from 'react';
import { Button } from 'react-bootstrap';

//Added Code for home page

// const siberianLogoUrl = 'https://cdn.siberian.dev/siberian.png';

// get the notifications
// const Notifications = [
//     {
//         day: 'Today',
//         messages: [
//             {
//                 id: 1,
//                 title: 'Datacorp',
//                 subText: 'Caleb Flakelar commented on Admin',
//                 time: '1 min ago',
//                 icon: 'mdi mdi-comment-account-outline',
//                 variant: 'primary',
//                 isRead: false,
//             },
//             {
//                 id: 2,
//                 title: 'Admin',
//                 subText: 'New user registered.',
//                 time: '1 hours ago',
//                 icon: 'mdi mdi-account-plus',
//                 variant: 'info',
//                 isRead: true,
//             },
//         ],
//     },
//     {
//         day: 'Yesterday',
//         messages: [
//             {
//                 id: 1,
//                 title: 'Cristina Pride',
//                 subText: 'Hi, How are you? What about our next meeting',
//                 time: '1 day ago',
//                 avatar: avatar1,
//                 isRead: true,
//             },
//         ],
//     },
//     {
//         day: '30 Dec 2021',
//         messages: [
//             {
//                 id: 1,
//                 title: 'Datacorp',
//                 subText: 'Caleb Flakelar commented on Admin',
//                 icon: 'mdi mdi-comment-account-outline',
//                 variant: 'primary',
//                 isRead: true,
//             },
//             {
//                 id: 2,
//                 title: 'Karen Robinson',
//                 subText: 'Wow ! this admin looks good and awesome design',
//                 avatar: avatar2,
//                 isRead: true,
//             },
//         ],
//     },
// ];

// get the profilemenu
const ProfileMenus = [
    // {
    //     label: 'My Account',
    //     icon: 'mdi mdi-account-circle',
    //     redirectTo: '#',
    // },
    // {
    //     label: 'Settings',
    //     icon: 'mdi mdi-account-edit',
    //     redirectTo: '#',
    // },
    // {
    //     label: 'Support',
    //     icon: 'mdi mdi-lifebuoy',
    //     redirectTo: '#',
    // },
    // {
    //     label: 'Lock Screen',
    //     icon: 'mdi mdi-lock-outline',
    //     redirectTo: '/account/lock-screen',
    // },
    {
        label: 'Logout',
        icon: 'mdi mdi-logout',
        redirectTo: '/logout',
    },
];

const FEATURES = [
    {
        name: 'Collections',
        redirectTo: '/collection',
        icon: 'dripicons-folder',
    },
    // {
    //     name: 'Collections',
    //     redirectTo: '/collection',
    //     icon: ,
    // },
];

type TopbarProps = {
    hideLogo?: boolean,
    navCssClasses?: string,
    openLeftMenuCallBack?: () => void,
    topbarDark?: boolean,
};

const Topbar = ({
    hideLogo,
    navCssClasses,
    isHomePage,
    openLeftMenuCallBack,
    topbarDark,
}: TopbarProps): React$Element<any> => {
    const dispatch = useDispatch();

    const location = useLocation();
    // console.log(location);

    const [isopen, setIsopen] = useState(false);
    const [user, setUser] = useState(null);
    const [imgSrc, setImgSrc] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const authCtx = useContext(AuthContext);

    const [dropdownOpen, setDropdownOpen] = useState(false);

    /*
     * toggle apps-dropdown
     */
    const toggleDropdown = ({ dropdownOpen: boolean }) => {
        setDropdownOpen(!dropdownOpen);
    };

    const navbarCssClasses = navCssClasses || '';
    const navbarHomeClasses = isHomePage || '';
    const containerCssClasses = !hideLogo ? 'container-fluid' : '';

    const { layoutType, leftSideBarType } = useSelector((state) => ({
        layoutType: state.Layout.layoutType,
        leftSideBarType: state.Layout.leftSideBarType,
    }));

    /**
     * Toggle the leftmenu when having mobile screen
     */
    const handleLeftMenuCallBack = () => {
        setIsopen((prevState) => !prevState);
        if (openLeftMenuCallBack) openLeftMenuCallBack();

        switch (layoutType) {
            case layoutConstants.LAYOUT_VERTICAL:
                // condition added
                if (window.innerWidth >= 768) {
                    if (leftSideBarType === 'fixed' || leftSideBarType === 'scrollable')
                        dispatch(changeSidebarType(layoutConstants.LEFT_SIDEBAR_TYPE_CONDENSED));
                    if (leftSideBarType === 'condensed')
                        dispatch(changeSidebarType(layoutConstants.LEFT_SIDEBAR_TYPE_FIXED));
                }
                break;

            case layoutConstants.LAYOUT_FULL:
                if (document.body) {
                    document.body.classList.toggle('hide-menu');
                }
                break;
            default:
                break;
        }
    };

    /**
     * Toggles the right sidebar
     */
    const handleRightSideBar = () => {
        dispatch(showRightSidebar());
    };
    // const API_URL = 'https://api.siberian.dev';
    const API_URL = process.env.REACT_APP_API_URL;

    // const checkIfUserAlreadyLoggedIn = () => {
    //     setLoading(true);
    //     const accessToken = localStorage?.getItem('siberian_access_token');
    //     const refreshToken = localStorage?.getItem('siberian_refresh_token');
    //     // console.log('tokens from locl storage: ', accessToken, refreshToken);
    //     if (accessToken) {
    //         console.log('In access token.');
    //         const decodedAccessToken = jwt_decode(accessToken);
    //         const user = {
    //             displayName: decodedAccessToken.name,
    //             photos: [{ value: '' }],
    //             usernaame: decodedAccessToken.name,
    //             email: decodedAccessToken.email,
    //         };
    //         // console.log('decoded: ', user);
    //         setUser(user);
    //         setLoading(false);
    //     }
    //     setLoading(false);
    //     return;
    // };

    useEffect(() => {
        // console.log('API_URL: ', API_URL);
        // const getUser = async () => {
        //     // console.log('INSIDE GET USER');
        //     // console.log('TOPBAR');
        //     const st = localStorage.getItem('st');
        //     if (st) {
        //         setLoading(true);
        //         // console.log('in st');
        //         try {
        //             const response = await fetch(`${API_URL}/auth/login/success?st=${st}`, {
        //                 method: 'GET',
        //                 credentials: 'include',
        //                 headers: {
        //                     Accept: 'application/json',
        //                     'Content-Type': 'application/json',
        //                     'Access-Control-Allow-Credentials': true,
        //                 },
        //             });
        //             if (response.status !== 200) throw new Error('authentication has been failed.');
        //             const data = await response.json();
        //             // console.log(data);
        //             // setIsLoggedIn(true);
        //             if (data.success) {
        //                 setUser({ ...data.user, displayName: data.user.name, photos: [{ value: '' }] });
        //                 setLoading(false);
        //             } else {
        //                 throw new Error('Login Error');
        //             }
        //         } catch (err) {
        //             // setIsLoggedIn(true);
        //             console.log(err.message);
        //             setError(err.message);
        //         }
        //         setLoading(false);
        //     } else {
        //         setLoading(true);
        //         fetch(`${API_URL}/auth/login/success`, {
        //             method: 'GET',
        //             credentials: 'include',
        //             headers: {
        //                 Accept: 'application/json',
        //                 'Content-Type': 'application/json',
        //                 'Access-Control-Allow-Credentials': true,
        //             },
        //         })
        //             .then((response) => {
        //                 // console.log('FAILED TO GET USER');
        //                 if (response.status === 200) return response.json();
        //                 throw new Error('authentication has been failed!');
        //             })
        //             .then((resObject) => {
        //                 console.log('RESULT OBJECT');
        //                 // dispatch(oAuthLoginUser(resObject));
        //                 // console.log('resObject-> ', resObject);
        //                 // console.log(resObject.user);
        //                 //to set the session token of the user logged in via google.
        //                 // if (resObject) {
        //                 //     if (resObject.success) {
        //                 //         localStorage.setItem('st', resObject.st);
        //                 //     }
        //                 // }
        //                 setUser(resObject.user);
        //                 setLoading(false);
        //             })
        //             .catch((err) => {
        //                 console.log(err);
        //                 setError(err.message);
        //             });
        //         setLoading(false);
        //     }
        // };
        authCtx.getUser();

        // checkIfUserAlreadyLoggedIn();
    }, []);

    return (
        <>
            <div
                className={`${
                    location.pathname !== '/home'
                        ? classNames('navbar-custom', navbarCssClasses)
                        : classNames('navbar-custom', navbarHomeClasses)
                }`}>
                <div className={`${containerCssClasses}`}>
                    {location.pathname === '/home' || (
                        <Link to="/" className="topnav-logo">
                            <span className="topnav-logo-lg">
                                <img
                                    style={{ width: 153, height: 49, objectFit: 'cover' }}
                                    src={location.pathname !== '/home' ? siberianLogoWhite : siberianLogoWhite}
                                    alt="logo"
                                />
                            </span>
                            <span className="topnav-logo-sm">
                                <img
                                    style={{ width: 125, height: 28, objectFit: 'cover' }}
                                    // src={topbarDark ? siberianLogoWhite : siberianLogoWhite}
                                    src={location.pathname !== '/home' ? siberianLogoWhite : siberianLogoWhite}
                                    alt="logo"
                                />
                            </span>
                        </Link>
                    )}

                    <ul className="list-unstyled topbar-menu float-end mb-0">
                        {/* <li className="notification-list topbar-dropdown d-xl-none">
                            <SearchDropdown />
                        </li> */}
                        {/* <li className="dropdown notification-list topbar-dropdown d-none d-lg-block">
                            <LanguageDropdown />
                        </li> */}
                        {/* <li className="dropdown notification-list">
                            <NotificationDropdown notifications={Notifications} />
                        </li> */}
                        {/* <li className="dropdown notification-list d-none d-sm-inline-block">
                            <AppsDropdown />
                        </li>
                        <li className="notification-list">
                            <button
                                className="nav-link dropdown-toggle end-bar-toggle arrow-none btn btn-link shadow-none"
                                onClick={handleRightSideBar}>
                                <i className="dripicons-gear noti-icon"></i>
                            </button> 
                        </li> */}
                        <li className="dropdown notification-list">
                            {!authCtx.isLoading ? (
                                authCtx.user && authCtx.isLoggedIn ? (
                                    <div className="d-flex align-items-center">
                                        {/* {console.log('in dropdown ')} */}
                                        <Dropdown
                                            show={dropdownOpen}
                                            onToggle={toggleDropdown}
                                            style={{ positon: 'relative', right: '-6%' }}>
                                            <Dropdown.Toggle
                                                variant="link"
                                                id="dropdown-apps"
                                                as={Link}
                                                to="#"
                                                onClick={toggleDropdown}
                                                className="nav-link dropdown-toggle arrow-none">
                                                <i className="dripicons-view-apps noti-icon"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu
                                                align={'end'}
                                                className="dropdown-menu-animated dropdown-lg p-0">
                                                <div onClick={toggleDropdown} className="p-2">
                                                    <div className="row g-0">
                                                        {FEATURES.map((item, i) => (
                                                            <div className="col" key={i}>
                                                                <Link
                                                                    className="dropdown-icon-item"
                                                                    to={item.redirectTo}>
                                                                    {/* <img src={item.icon} alt="" /> */}
                                                                    <i className={item.icon} />
                                                                    <span>{item.name}</span>
                                                                </Link>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </Dropdown.Menu>
                                        </Dropdown>

                                        <ProfileDropdown
                                            profilePic={
                                                authCtx.user && authCtx.user.photos[0].value != ''
                                                    ? authCtx.user.photos[0].value
                                                    : noProfilePic
                                            }
                                            menuItems={ProfileMenus}
                                            username={authCtx.user.displayName}
                                            userTitle={<i className={'mdi mdi-check-decagram'}></i>}
                                            //
                                        />
                                    </div>
                                ) : (
                                    <>
                                        {/* {console.log('In login btns')} */}
                                        <Link to="/login" className=" mt-2 btn btn-primary">
                                            Login
                                        </Link>

                                        <Link to="/signup" className=" mx-2 mt-2 btn btn-primary">
                                            Register
                                        </Link>

                                        {/* <button className="mt-2 btn btn-primary" style={{borderRadius:'50%'}}>i</button> */}
                                    </>
                                )
                            ) : (
                                <>
                                    {/* {console.log('In Loading')} */}
                                    <div className="mt-2">{'Loading...'}</div>
                                </>
                            )}
                        </li>
                    </ul>

                    {/* toggle for vertical layout */}
                    {/* {(layoutType === layoutConstants.LAYOUT_VERTICAL || layoutType === layoutConstants.LAYOUT_FULL) && (
                        <button className="button-menu-mobile open-left" onClick={handleLeftMenuCallBack}>
                            <i className="mdi mdi-menu" />
                        </button>
                    )} */}

                    {/* toggle for horizontal layout */}
                    {layoutType === layoutConstants.LAYOUT_HORIZONTAL && (
                        <Link
                            to="#"
                            className={classNames('navbar-toggle', { open: isopen })}
                            onClick={handleLeftMenuCallBack}>
                            <div className="lines">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </Link>
                    )}

                    {/* toggle for detached layout */}
                    {layoutType === layoutConstants.LAYOUT_DETACHED && (
                        <Link to="#" className="button-menu-mobile disable-btn" onClick={handleLeftMenuCallBack}>
                            <div className="lines">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </Link>
                    )}
                    {/* <TopbarSearch /> */}
                </div>
            </div>
        </>
    );
};

export default Topbar;
